// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2-PAr","subheader":"ReorderModal_subheader__3hy8l","listWrap":"ReorderModal_listWrap__1gIzP"};